const comparisonTable = (function() {
  const openPopupClass = 'show';

  const createPopupHandler = function(section) {
    const drawer = section.querySelector('[data-comparison-chart-popup--drawer]');
    if (!drawer) return;

    const closeBtn = drawer.querySelector('[data-comparison-chart-popup--close]');
    const backdrop = drawer.querySelector('[data-comparison-chart-popup--backdrop]');
    const sectionId = section.getAttribute('data-section-id');
    if (!sectionId) return;

    drawer.querySelectorAll('[data-video-control]').forEach(button => {
      const video = button.previousElementSibling;
      const playIcon = button.querySelector('.play-icon');
      const pauseIcon = button.querySelector('.pause-icon');
    
      if (
        video &&
        video.tagName === 'VIDEO' &&
        playIcon &&
        pauseIcon
      ) {
        button.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            playIcon.classList.add('hidden');
            pauseIcon.classList.remove('hidden');
          } else {
            video.pause();
            playIcon.classList.remove('hidden');
            pauseIcon.classList.add('hidden');
          }
        });
    
        video.addEventListener('ended', () => {
          playIcon.classList.remove('hidden');
          pauseIcon.classList.add('hidden');
        });
    
        video.addEventListener('pause', () => {
          playIcon.classList.remove('hidden');
          pauseIcon.classList.add('hidden');
        });
    
        video.addEventListener('play', () => {
          playIcon.classList.add('hidden');
          pauseIcon.classList.remove('hidden');
        });
      }
    });

    const showPopup = function() {
      drawer.style.display = 'block';
      setTimeout(() => {
        drawer.classList.add(openPopupClass);
      }, 200);
    };

    const hidePopup = function() {
      drawer.classList.remove(openPopupClass);
      setTimeout(() => {
        drawer.style.display = 'none';
      }, 500);
    };

    if (closeBtn) {
      closeBtn.addEventListener('click', hidePopup);
    }
    if (backdrop) {
      backdrop.addEventListener('click', hidePopup);
    }

    document.body.addEventListener(`open-comparison-popup-${sectionId}`, showPopup);
    section.style.display = '';
  };

  return {
    init: function() {
      const sections = document.querySelectorAll('[data-comparison-chart-popup]');
      sections.forEach(section => {
        createPopupHandler(section);
      });
    }
  };
})();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    comparisonTable.init();
  });
} else {
  comparisonTable.init();
}